export const getReport = ({ report }) => report.report;
export const getMonths = ({ report }) => report.months;
export const getUsers = ({ report }) => report.users;
export const getColumns = ({ report }) => report.columns;
